function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import * as actionTypes from './actionTypes';
export const fetchOrganizations = (queryParams)=>({
        type: actionTypes.FETCH_ORGANIZATIONS,
        payload: {
            queryParams
        }
    });
export const fetchOrganizationsSuccess = (organizations, organizationsCount)=>({
        type: actionTypes.FETCH_ORGANIZATIONS_SUCCESS,
        payload: {
            organizations,
            organizationsCount
        }
    });
export const fetchOrganizationsError = (error)=>({
        type: actionTypes.FETCH_ORGANIZATIONS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchOrganizationMemberships = ()=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS,
        [WAIT_FOR_ACTION]: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS,
        [ERROR_ACTION]: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR
    });
export const fetchOrganizationMembershipsSuccess = (organizationMemberships)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS,
        payload: {
            organizationMemberships
        }
    });
export const fetchOrganizationMembershipsError = (error)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchOrganizationMembershipDetails = (organizationMembership)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS,
        payload: {
            organizationMembership
        }
    });
export const fetchOrganizationMembershipDetailsSuccess = (organizationMembershipDetails)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS_SUCCESS,
        payload: {
            organizationMembershipDetails
        }
    });
export const fetchOrganizationMembershipDetailsError = (error)=>({
        type: actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchOrganizationTemplate = (countryCode = null)=>({
        type: actionTypes.FETCH_ORGANIZATION_TEMPLATE,
        payload: {
            countryCode
        }
    });
export const fetchOrganizationTemplateSuccess = (organizationTemplate, countryCode)=>({
        type: actionTypes.FETCH_ORGANIZATION_TEMPLATE_SUCCESS,
        payload: {
            countryCode,
            organizationTemplate
        }
    });
export const fetchOrganizationTemplateError = (error)=>({
        type: actionTypes.FETCH_ORGANIZATION_TEMPLATE_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const createOrganization = (organizationProposal, businessEmail)=>({
        type: actionTypes.CREATE_ORGANIZATION,
        payload: _object_spread_props(_object_spread({}, organizationProposal), {
            organizationMembershipDetails: {
                businessEmail
            }
        })
    });
export const createOrganizationSuccess = ()=>({
        type: actionTypes.CREATE_ORGANIZATION_SUCCESS
    });
export const createOrganizationError = (error)=>({
        type: actionTypes.CREATE_ORGANIZATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const joinOrganization = (organization, businessEmail)=>({
        type: actionTypes.JOIN_ORGANIZATION,
        payload: {
            organization,
            organizationMembershipDetails: {
                businessEmail
            }
        }
    });
export const joinOrganizationSuccess = ()=>({
        type: actionTypes.JOIN_ORGANIZATION_SUCCESS
    });
export const joinOrganizationError = (error)=>({
        type: actionTypes.JOIN_ORGANIZATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const leaveOrganization = (organizationMembership)=>({
        type: actionTypes.LEAVE_ORGANIZATION,
        payload: {
            organizationMembership
        }
    });
export const leaveOrganizationSuccess = (organizationMembership)=>({
        type: actionTypes.LEAVE_ORGANIZATION_SUCCESS,
        payload: {
            organizationMembership
        }
    });
export const leaveOrganizationError = (error)=>({
        type: actionTypes.LEAVE_ORGANIZATION_ERROR,
        error
    });
